export const sortByOrderSelector = (data) => (
  Array.isArray(data) ? data.sort((a, b) => a.order - b.order) : []
);
